export function truncateText(text: string, length = 100) {

    const maxLength = length;

    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}

export function normalize(str: string) { 
  return str.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}